module.exports = __webpack_public_path__ + "static/media/Earth.67ee87ba.svg";